
export const getTypeModalState = (variantsType, codeResponse, state, omitCode = 500) => {
    const filterVariantType = Object.keys(variantsType)
    const arrayVariantType = filterVariantType.map((value, key) => parseFloat(value))
    const filterArrayVariantType = arrayVariantType.filter((value) => value !== 500)

    const get = (obj, path, defaultValue = undefined) => {
      const travel = regexp =>
        String.prototype.split
          .call(path, regexp)
          .filter(Boolean)
          .reduce((res, key) => (res !== null && res !== undefined ? res[key] : res), obj);
      const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);
      return result === undefined || result === obj ? defaultValue : result;
    };

    if (codeResponse === undefined) return get(state, ['modal', 'type']); 
  
    if (filterArrayVariantType.includes(codeResponse)) return codeResponse

  return omitCode;
}